import isNil from 'lodash/isNil'
import * as Dictionary from './dictionary'
import * as Types from './types'

export const helpOption = (key: string): Types.HelpEntry  => Dictionary.HELP_DICTIONARY[key]

export const helpExists = (key: string): boolean => !isNil(helpOption(key))



// WEBPACK FOOTER //
// ./src/components/help/utils.ts